import {Select} from "./Select.js";

export class CompanyCategorySelect extends Select {
    template() {
        const {addClassName = ""} = this.$props;
        return `
            <div class="interactive-form-wrap js-interactive-form-wrap">
            
              <i class="sign-icons-arrow-mini"></i>
              <select id="joinTeamSector" class="join-select-input interactive-form-input ${addClassName}" 
                  data-required-yn="Y" 
                  data-empty-msg="${i18next.t(login.selectCompanyCategory)}">>
                    ${this.getOptionsTemplate()}
              </select>
              <span class="interactive-form-placeholder">${i18next.t(login.companyCategory)}</span>
            </div>
              <p class="error-txt-wrap">
                <span class="js-error-txt"></span>
              </p>`
    }

    getQuerySelectorOfSelect() {
        return `#joinTeamSector`
    }

    getOptionsDataArr() {
        // 수정시 주의 Global Hubspot > Deal > Industry(Eng) Deal 프로퍼티로 쓰고 있음
        if (Often.isGlobal()) {
            return [
                {value: "Consulting Services", text: `${i18next.t(login.category.consult)}`}, //Consulting Services
                {value: "Creative", text: `${i18next.t(login.category.creative)}`}, //Creative
                {value: "Manufacturing", text: `${i18next.t(login.category.produce)}`}, //Manufacturing
                {value: "Information Technology (IT)", text: `${i18next.t(login.category.tech)}`}, //Software & IT Services
                {value: "Business Franchises", text: `${i18next.t(login.category.franchise)}`}, //Business Franchises
                {value: "Distribution", text: `${i18next.t(login.category.logistics)}`}, //Distribution & Logistics
                {value: "Arts and Entertainment", text: `${i18next.t(login.category.entertain)}`}, //Arts & Entertainment
                {value: "Public Administration", text: `${i18next.t(login.category.public)}`}, //Public Administration
                {value: "Construction", text: `${i18next.t(login.category.construct)}`}, //Construction
                {value: "Healthcare", text: `${i18next.t(login.category.medical)}`}, //Healthcare
                {value: "Service", text: `${i18next.t(login.category.service)}`}, //Service
                {value: "Finance", text: `${i18next.t(login.category.finance)}`}, //Finance
                {value: "Association", text: `${i18next.t(login.category.association)}`}, //Association
                {value: "Education and Research", text: `${i18next.t(login.category.research)}`}, //Education and Research
                {value: "Agriculture", text: `${i18next.t(login.category.primaryIndustry)}`}, //Agriculture
                {value: "Others", text: `${i18next.t(login.category.etc)}`}, //Others
            ];
        }
        return [
            {value: "", text: `${i18next.t(login.selectCompanyCategory)}`},
            {value: "Produce", text: `${i18next.t(login.category.produce)}`},
            {value: "IT", text: `${i18next.t(login.category.tech)}`},
            {value: "Franchise", text: `${i18next.t(login.category.franchise)}`},
            {value: "Logistics", text: `${i18next.t(login.category.logistics)}`},
            {value: "Entertain", text: `${i18next.t(login.category.entertain)}`},
            {value: "Public", text: `${i18next.t(login.category.public)}`},
            {value: "Construct", text: `${i18next.t(login.category.construct)}`},
            {value: "Service", text: `${i18next.t(login.category.service)}`},
            {value: "Tax", text: `${i18next.t(login.category.tax)}`},
            {value: "Medical", text: `${i18next.t(login.category.medical)}`},
            {value: "Finance", text: `${i18next.t(login.category.finance)}`},
            {value: "Association", text: `${i18next.t(login.category.association)}`},
            {value: "Research", text: `${i18next.t(login.category.research)}`},
            {value: "PrimaryIndustry", text: `${i18next.t(login.category.primaryIndustry)}`},
            {value: "etc", text: `${i18next.t(login.category.etc)}`}, //etc
        ];
    }

}
